import { API, axiosInstance } from "lib";

// chart of account
export const getChartOfAccountList = (data = {}) => {
    return axiosInstance
        .post(API.GET_CHART_ACCOUNT_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
            ;
        });
};

export const getChartOfAccountDetails = (data = {}) => {
    return axiosInstance
        .post(API.GET_CHART_OF_ACCOUNT_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }

        });
};

// Delete chart of account
export const deleteChartOfAccount = (data = {}) => {
    return axiosInstance
        .post(API.DELETE_CHART_OF_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }

        });
};
// update chart of account
export const updateChartOfAccount = (data = {}) => {
    return axiosInstance
        .post(API.EDIT_CHART_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
            // throw err;
        });
};
export const createChartOfAccount = (data = {}) => {
    return axiosInstance
        .post(API.CREATE_CHART_OF_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }

        });
};

export const updateApproveStatus = (data = {}) => {
    return axiosInstance
        .post(API.UPDATE_APPROVE, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }

        });
};

export const getDropDownChartOfAccount = (data = {}) => {
    return axiosInstance
        .post(API.GET_CHART_OF_ACCOUNT_TYPE_WISE, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }

        });
};


export const updateCharOfAccountCategory = (data = {}) => {
    return axiosInstance
        .post(API.UPDATE_CHAROF_EXPENSE_CATEGORY, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }

        });
};

export const deleteCharOfAccountCategory = (data = {}) => {
    return axiosInstance
        .post(API.DELETE_CHAROF_EXPENSE_CATEGORY, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }

        });
};

export const getMoneyInListApi = (data = {}) => {
    return axiosInstance
        .post(API.MONEY_IN, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }

        });
};

export const getMoneyOutListApi = (data = {}) => {
    return axiosInstance
        .post(API.MONEY_OUT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }

        });
};


export const getVoucherReport = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_VOUCHER_REPORT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getFuelReport = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_FUEL_REPORT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getPaynowDownloadApi = (data = {}) => {
    return axiosInstance
        .get(`${API.GET_PAYMENT_STETMENT_DOWNLOAD}?firm_id=${data?.firm_id}`, {})
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};

export const getPaymentTransactionListApi = (data = {}) => {
    return axiosInstance
        .post(`${API.GET_PAYMENT_TRANSACTION_LIST}`, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};


export const getPaymentTransactionDetailsApi = (data = {}) => {
    return axiosInstance
        .post(`${API.GET_PAYMENT_TRANSACTION_DETAILS}`, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};


export const getServiceTransactionDetailsApi = (data = {}) => {
    return axiosInstance
        .post(`${API.GET_SERVICE_TRANSACTION_DETAILS}`, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};

export const addPaymentGenExpApi = (data = {}) => {
    return axiosInstance
        .post(`${API.ADD_PAYMENT_GEN_EXP}`, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};

export const addPaymentServiceApi = (data = {}) => {
    return axiosInstance
        .post(`${API.ADD_PAYMENT_SERVICE}`, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};



export const addTransationFreightForPayNow = (data = {}) => {
    return axiosInstance
        .post(`${API.ADD_ADV_FREIGHT}`, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};